import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import WarningIcon from '../../assets/img/rich_icons/warning.svg';
import Modal from './Modal';

const ConfirmationModal = (props) => {
  const {
    t,
    isOpen,
    type,
    onClose,
    onConfirm,
    textBtnConfirm,
    textBtnClose,
    loadingOnConfirm,
    reverseButtons,
    closeRight,
    className,
    labelConfirm,
    secondLabelConfirm,
    isDisabled,
    mainIcon,
    headerIcon,
    title,
    disableCancel,
    btnConfrimType,
    btnConfirmName,
  } = props;
  const buttons = [
    {
      name: btnConfirmName || 'confirmation',
      text: textBtnConfirm,
      action: onConfirm,
      isLoading: loadingOnConfirm,
      disabled: isDisabled,
      type: btnConfrimType,
    },
  ];
  if (!disableCancel) {
    buttons.push({
      name: 'confirmClose',
      text: textBtnClose,
    });
  }
  return (
    <Modal
      className={className}
      isOpen={isOpen}
      onClose={onClose}
      title={t(title)}
      centered
      type={type}
      buttons={closeRight ? buttons : buttons.reverse()}
      iconName={headerIcon}
      headerButtons={false}
      reverseButtons={reverseButtons}
      backDrop={false}
    >
      <div className="confirm-modal">
        <img src={mainIcon} alt="" />
        <p>{t(labelConfirm)}</p>
        {secondLabelConfirm && <p>{t(secondLabelConfirm)}</p>}
      </div>
    </Modal>
  );
};

ConfirmationModal.defaultProps = {
  isOpen: false,
  type: 'danger',
  onClose: () => {},
  onConfirm: () => {},
  textBtnConfirm: 'buttonSave',
  textBtnClose: 'buttonBack',
  labelConfirm: 'modalConfirmMsg',
  reverseButtons: true,
  closeRight: true,
  loadingOnConfirm: true,
  isDisabled: null,
  mainIcon: WarningIcon,
  headerIcon: 'exclamation-triangle',
  title: 'modalConfirmTitle',
  disableCancel: false,
};

ConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  type: PropTypes.string,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  textBtnConfirm: PropTypes.string,
  textBtnClose: PropTypes.string,
  labelConfirm: PropTypes.string,
  reverseButtons: PropTypes.bool,
  closeRight: PropTypes.bool,
  loadingOnConfirm: PropTypes.bool,
  isDisabled: PropTypes.func,
  title: PropTypes.string,
  headerIcon: PropTypes.string,
  disableCancel: PropTypes.bool,
};

export default withNamespaces()(ConfirmationModal);
